import axios from 'axios';
import { useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';

const useUploadFile = () => {
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const queryClient = useQueryClient();
  const { mutate, data, isLoading } = useMutation(
    async ({ file, resourceType, idCard }) => {
      let formData = new FormData();
      formData.append('file', file);
      setUploadProgress(0);
      let endpoint = '';
      switch (resourceType) {
        case 'document': {
          console.log('uploading document csv');
          endpoint = '/idcards/'+idCard.id+'/documents/import';
          break;
        }
        case 'equipment': {
          console.log('uploading equipment csv');
          endpoint = '/idcards/'+idCard.id+'/equipment/import';
          break;
        }
        default: endpoint = '';
      }
      return (
        await axios.post(endpoint, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          timeout: 6000000, // we don't want timeout while upload is happening
          onUploadProgress, // event for onUploadProgress
        })
      ).data;
    },
    {
      onSuccess: (resData, { idCard }) => {
        setUploadSuccess(true);
        queryClient.invalidateQueries(['idCards', { tagId: idCard.tagId }], { exact: true });
        toast.success('File uploaded', {
          position: toast.POSITION.TOP_RIGHT,
        });
      },
      onError: (err) => {
        setUploadSuccess(false);
        let errorMsg = err?.response?.data?.message || err.message;
        setErrorMessage(errorMsg);
        // toast.error(`${errorMsg}`, {
        //   position: toast.POSITION.TOP_RIGHT,
        //   autoClose: 20000,
        // });
      },
    }
  );

  const onUploadProgress = (event) => {
    if (event) {
      if (event.loaded && event.loaded > 0) {
        setUploadProgress(Math.round((100 * event.loaded) / event.total));
      }
    }
  };
  const uploadFile = (file, resourceType, idCard, options) => mutate({ file, resourceType, idCard }, options);

  return {
    uploadFile,
    isLoading,
    uploadProgress,
    uploadSuccess,
    errorMessage
  };
};

export default useUploadFile;
